import { Navigate, useSearchParams } from 'react-router-dom';
import { fulfillmentDeepLinkPath } from '../utils/fulfillmentApi.mjs';

/**
 * Legacy bookmark `/fulfillment/ozon` → единая страница `/fulfillment?mp=ozon`.
 * Старый standalone UI снят: операторский путь — Fulfillment.jsx.
 */
export default function OzonFulfillment() {
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get('account_id') || undefined;
  return (
    <Navigate
      to={fulfillmentDeepLinkPath({ mp: 'ozon', accountId })}
      replace
    />
  );
}
